// src/modules/purityAnalyzer/api.js
// API client for the Gold Purity Analyzer. All endpoints under /api/v1/purity/

import API from '../../services/api';
import { API_ENDPOINTS } from './constants/purityConstants';

// --- Copper Calibration ---
export const createCalibration = (data) => API.post(API_ENDPOINTS.CALIBRATIONS, data);
export const fetchCalibrations = (params) => API.get(API_ENDPOINTS.CALIBRATIONS, { params });
export const fetchCalibration = (id) => API.get(`${API_ENDPOINTS.CALIBRATIONS}/${id}`);
export const fetchCalibrationAudit = (id) => API.get(`${API_ENDPOINTS.CALIBRATIONS}/${id}/audit`);
export const activateCalibration = (id) => API.post(`${API_ENDPOINTS.CALIBRATIONS}/${id}/activate`);
export const rollbackCalibration = (id) => API.post(`${API_ENDPOINTS.CALIBRATIONS}/${id}/rollback`);
export const archiveCalibration = (id) => API.post(`${API_ENDPOINTS.CALIBRATIONS}/${id}/archive`);
export const compareCalibrations = (a, b) =>
  API.get(`${API_ENDPOINTS.CALIBRATIONS}/compare`, { params: { a, b } });

// --- Purity Tests ---
export const previewTest = (data) => API.post(`${API_ENDPOINTS.TESTS}/preview`, data);
export const runTest = (data) => API.post(API_ENDPOINTS.TESTS, data);
export const fetchTests = (params) => API.get(API_ENDPOINTS.TESTS, { params });
export const fetchTest = (id) => API.get(`${API_ENDPOINTS.TESTS}/${id}`);
export const fetchTestAudit = (id) => API.get(`${API_ENDPOINTS.TESTS}/${id}/audit`);
export const updateTest = (id, data) => API.patch(`${API_ENDPOINTS.TESTS}/${id}`, data);
export const reverseTest = (id, reason) =>
  API.post(`${API_ENDPOINTS.TESTS}/${id}/reverse`, { reason });

// --- XRF Verification + Learning ---
export const verifyTestXrf = (testId, data) =>
  API.post(`${API_ENDPOINTS.TESTS}/${testId}/xrf`, data);
export const fetchLearningQueue = (params) => API.get(API_ENDPOINTS.LEARNING, { params });
export const proposeLearning = (xrfId) =>
  API.post(`${API_ENDPOINTS.LEARNING}/${xrfId}/propose`);
export const approveLearning = (xrfId, data) =>
  API.post(`${API_ENDPOINTS.LEARNING}/${xrfId}/approve`, data);
export const rejectLearning = (xrfId, data) =>
  API.post(`${API_ENDPOINTS.LEARNING}/${xrfId}/reject`, data);

// --- Calibration Dataset Versions ---
export const fetchVersions = (params) => API.get(API_ENDPOINTS.VERSIONS, { params });
export const fetchVersion = (id) => API.get(`${API_ENDPOINTS.VERSIONS}/${id}`);
export const activateVersion = (id, rollback = false) =>
  API.post(`${API_ENDPOINTS.VERSIONS}/${id}/activate`, { rollback });
export const addManualPoint = (id, data) =>
  API.post(`${API_ENDPOINTS.VERSIONS}/${id}/add-point`, data);

// --- Machines ---
export const fetchMachines = (params) => API.get(API_ENDPOINTS.MACHINES, { params });
export const createMachine = (data) => API.post(API_ENDPOINTS.MACHINES, data);
export const updateMachine = (id, data) => API.patch(`${API_ENDPOINTS.MACHINES}/${id}`, data);
export const archiveMachine = (id) => API.post(`${API_ENDPOINTS.MACHINES}/${id}/archive`);

// --- Deduction Settings (HM / Non-HM) ---
export const fetchDeductionSettings = () => API.get(API_ENDPOINTS.DEDUCTION_SETTINGS);
export const updateDeductionSettings = (data) => API.patch(API_ENDPOINTS.DEDUCTION_SETTINGS, data);

// --- Dashboard + Analytics ---
export const fetchDashboard = (params) => API.get(API_ENDPOINTS.DASHBOARD, { params });
export const fetchChart = (chartKey, params) =>
  API.get(`${API_ENDPOINTS.ANALYTICS}/${chartKey}`, { params });

// --- Cross-module lookups (existing collections; no duplication) ---
export const searchCustomers = (search) =>
  API.get('/customers', { params: { search, page: 1, limit: 10 } });
export const searchWalkInCases = (search) =>
  API.get('/walk-in-cases', { params: { search, page: 1, limit: 10 } });
export const searchPledgeCases = (search) =>
  API.get('/pledge-release-cases', { params: { search, page: 1, limit: 10 } });
export const fetchBranchList = () =>
  API.get('/branches', { params: { page: 1, limit: 100 } });
